const fetchInvites = (state) => {
  state.isLoading = true
  state.error = null
  state.invites = []
}

const fetchInvitesSuccess = (state, companies) => {
  state.isLoading = false
  state.error = null
  state.invites = companies
}

const fetchInvitesError = (state, error) => {
  state.isLoading = false
  state.error = error
  state.invites = []
}

export default {
  fetchInvites, fetchInvitesSuccess, fetchInvitesError,
}
